module.exports = __webpack_public_path__ + "img/jxjykf.fa477a5e.png";